import defaultConfig from "./defaultConfig";
import templateConfig from "./templateConfig";

const rootNode = document.getElementById("spektrixBookingPathway");
const INSTANCE = rootNode && JSON.parse(rootNode.getAttribute("instance"));
const SITE_URL = rootNode?.getAttribute("site-url");
const AJAX_URL = SITE_URL + "/wp-admin/admin-ajax.php";
const DOMAIN_NAME =
    rootNode && rootNode.getAttribute("domain-name")
        ? rootNode.getAttribute("domain-name")
        : "https://system.spektrix";
const CLIENT_NAME = rootNode?.getAttribute("client-name");
const { ticket_type_names, ...restTemplateConfig } = templateConfig;

const projectConfig = window.PATHWAY_CONFIG || {    
        SITE_URL: SITE_URL,
        AJAX_URL: AJAX_URL,
        DOMAIN_NAME: DOMAIN_NAME,
        CLIENT_NAME: CLIENT_NAME,
        SPEKTRIX_API_URL: `${DOMAIN_NAME}/${CLIENT_NAME}/api/v3`,
        SPEKTRIX_PLUGIN_URL: `${SITE_URL}/wp-content/uploads/cog-wp-spektrix`,
        // Event related data
        INSTANCE: INSTANCE,
        TAGS: rootNode && JSON.parse(rootNode.getAttribute("tags")),
        EVENT: INSTANCE?.event,
        INSTANCE_ID: INSTANCE?.instance_id,
        PLAN_ID: INSTANCE?.plan_id,
        EVENT_LINK: SITE_URL + '?event-redirect=' + INSTANCE?.event?.event_id,
        OPTION_FIELDS: {
            default_ticket_type_name: ticket_type_names || ["Standard", "Restricted View", "Ticket & Book", "Meet and Greet", "Premium"],
            show_location_filters: true,
            use_iframe_basket: false,
            // max_tickets_bookable: 10,
            ...restTemplateConfig,
        },
    //     INSTANCE_PRICELIST: INSTANCE && INSTANCE.pricelist && JSON.parse(INSTANCE.pricelist).prices,
    //     INSTANCE_PRICELIST_WITH_COMMISSION:
    // UTILS.addCommissionToPriceList(INSTANCE_PRICELIST),
        SUPPLEMENTARY_INSTANCES: INSTANCE?.supplementary_instances && JSON.parse(INSTANCE.supplementary_instances),
    //     PRICE_DATA: INSTANCE?.price_data,
    //     PRICE_TICKETS: PRICE_DATA?.tickets,
    //     PRICE_BANDS: PRICE_DATA?.bands,
    //     DEFAULT_TICKET_PRICEBANDS:
    // UTILS.getBandsByTicketType(DEFAULT_TICKET_TYPE),
    //     STATUS: INSTANCE && JSON.parse(INSTANCE.status),
        ATTRIBUTES: INSTANCE?.attributes && JSON.parse(INSTANCE.attributes),
        HAS_BEST_AVAILABLE: INSTANCE?.attributes && JSON.parse(INSTANCE.attributes).hasBestAvailableOverlay,

};

const config = { ...defaultConfig, ...projectConfig };

export default config;
